// extracted by mini-css-extract-plugin
export var attachment = "_s2-a";
export var emailContainer = "_s2-4";
export var emailContentPaddedContainer = "_s2-b";
export var emailHeader = "_s2-6";
export var emailIframe = "_s2-3";
export var emailInfoIcon = "_s2-9";
export var emailShortenedSummary = "_s2-e";
export var infoDropdown = "_s2-0";
export var infoRowBoundedContent = "_s2-d";
export var internal = "_s2-5";
export var merchant = "_s2-8";
export var messageInputContainer = "_s2-h";
export var normal = "_s2-7";
export var replyCard = "_s2-f";
export var subtleButton = "_s2-1";
export var subtleButtonIconContainer = "_s2-2";
export var toggleViewRepliesButton = "_s2-c";
export var wrappingText = "_s2-g";